export default "/dist/files/participation_rate.6d81726c157f975cdb15e32363832f28.svg";